import { useState, useEffect } from "react";

export default function SortGame({ onComplete, color, dark, tier='builder' }: any) {
  const STARTER_SETS = [
    { items:[{id:'s1a',l:'🍎 Food',c:'need'},{id:'s1b',l:'🎮 Video Game',c:'want'},{id:'s1c',l:'🏠 Shelter',c:'need'},{id:'s1d',l:'🧸 Toy',c:'want'},{id:'s1e',l:'💧 Water',c:'need'},{id:'s1f',l:'🍬 Candy',c:'want'}],
      cats:['need','want'],labels:['✅ Needs','⭐ Wants'],clrs:['#10b981','#f59e0b'] },
    { items:[{id:'s2a',l:'🐷 Save $5',c:'save'},{id:'s2b',l:'🍦 Ice Cream',c:'spend'},{id:'s2c',l:'📚 Book',c:'save'},{id:'s2d',l:'🎬 Movie',c:'spend'},{id:'s2e',l:'🎁 Gift Fund',c:'save'},{id:'s2f',l:'🎮 App Buy',c:'spend'}],
      cats:['save','spend'],labels:['🐷 Save','💸 Spend'],clrs:['#3b82f6','#ef4444'] },
    { items:[{id:'s3a',l:'🌟 Allowance',c:'in'},{id:'s3b',l:'🎮 Game Rental',c:'out'},{id:'s3c',l:'🐕 Dog Walking',c:'in'},{id:'s3d',l:'🍕 Pizza',c:'out'},{id:'s3e',l:'🌿 Yard Work',c:'in'},{id:'s3f',l:'🎡 Fair Ride',c:'out'}],
      cats:['in','out'],labels:['💰 Money In','💸 Money Out'],clrs:['#10b981','#ef4444'] },
  ];
  const BUILDER_SETS = [
    { items:[{id:'b1a',l:'🏠 Rent',c:'need'},{id:'b1b',l:'🎬 Streaming',c:'want'},{id:'b1c',l:'🍎 Groceries',c:'need'},{id:'b1d',l:'✈️ Vacation',c:'want'},{id:'b1e',l:'💊 Medicine',c:'need'},{id:'b1f',l:'🎮 Gaming Sub',c:'want'}],
      cats:['need','want'],labels:['✅ Needs','⭐ Wants'],clrs:['#10b981','#f59e0b'] },
    { items:[{id:'b2a',l:'💳 Credit Card',c:'debt'},{id:'b2b',l:'🏦 Savings Acct',c:'asset'},{id:'b2c',l:'🚗 Car Loan',c:'debt'},{id:'b2d',l:'📈 Stocks',c:'asset'},{id:'b2e',l:'🎓 Student Loan',c:'debt'},{id:'b2f',l:'🏠 Property',c:'asset'}],
      cats:['debt','asset'],labels:['💸 Debt','💰 Asset'],clrs:['#ef4444','#10b981'] },
    { items:[{id:'b3a',l:'💰 Paycheck',c:'in'},{id:'b3b',l:'🏠 Rent',c:'out'},{id:'b3c',l:'📈 Dividends',c:'in'},{id:'b3d',l:'🚗 Car Pay',c:'out'},{id:'b3e',l:'🛒 Side Job',c:'in'},{id:'b3f',l:'📱 Phone Bill',c:'out'}],
      cats:['in','out'],labels:['💰 Income','💸 Expense'],clrs:['#10b981','#ef4444'] },
  ];
  const MASTER_SETS = [
    { items:[{id:'m1a',l:'🏛️ Gov Bond',c:'low'},{id:'m1b',l:'📈 Index Fund',c:'med'},{id:'m1c',l:'💵 Cash',c:'low'},{id:'m1d',l:'🏠 Real Estate',c:'med'},{id:'m1e',l:'🚀 Crypto',c:'high'},{id:'m1f',l:'🎰 Startup',c:'high'}],
      cats:['low','med','high'],labels:['🛡️ Low Risk','⚖️ Med Risk','🔥 High Risk'],clrs:['#10b981','#f59e0b','#ef4444'] },
    { items:[{id:'m2a',l:'🏦 Roth IRA',c:'adv'},{id:'m2b',l:'💹 Brokerage',c:'tax'},{id:'m2c',l:'💼 401(k)',c:'adv'},{id:'m2d',l:'🏠 Rental',c:'tax'},{id:'m2e',l:'🎓 529 Plan',c:'adv'},{id:'m2f',l:'💵 Cash Acct',c:'tax'}],
      cats:['adv','tax'],labels:['🛡️ Tax-Advantaged','💰 Taxable'],clrs:['#8b5cf6','#f59e0b'] },
    { items:[{id:'m3a',l:'💼 Salary',c:'active'},{id:'m3b',l:'🏠 Rental Income',c:'passive'},{id:'m3c',l:'🛒 Freelance',c:'active'},{id:'m3d',l:'📈 Dividends',c:'passive'},{id:'m3e',l:'🎓 Tutoring',c:'active'},{id:'m3f',l:'📚 Royalties',c:'passive'}],
      cats:['active','passive'],labels:['⚡ Active Income','💤 Passive Income'],clrs:['#0ea5e9','#10b981'] },
  ];

  const SETS = tier==='starter'?STARTER_SETS:tier==='master'?MASTER_SETS:BUILDER_SETS;
  const [set]    = useState(() => SETS[Math.floor(Math.random()*SETS.length)]);
  const [sorted, setSorted] = useState<Record<string,string[]>>(() => {
    const o: Record<string,string[]> = {}; set.cats.forEach(c => o[c]=[]); return o;
  });
  const [sel,   setSel]   = useState<string|null>(null);
  const [flash, setFlash] = useState<{id:string;ok:boolean}|null>(null);

  const placed   = (Object.values(sorted) as string[][]).flat();
  const unsorted = set.items.filter(x => !placed.includes(x.id));
  const allDone  = unsorted.length === 0;

  useEffect(() => { if (allDone) setTimeout(onComplete, 800); }, [allDone]);

  function pick(id: string) { setSel(s => s===id ? null : id); }
  function drop(cat: string) {
    if (!sel) return;
    const item = set.items.find(x => x.id===sel)!;
    const ok   = item.c === cat;
    setFlash({ id:sel, ok });
    setTimeout(() => {
      if (ok) setSorted(s => ({ ...s, [cat]:[...s[cat], sel!] }));
      setFlash(null); setSel(null);
    }, 420);
  }

  return (
    <div style={{ fontFamily:'Nunito' }}>
      {/* Header */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
        <span style={{ fontSize:13, fontWeight:900, color }}>🎯 Tap item → tap bucket</span>
        <span style={{ fontSize:12, fontWeight:800, color:'#6b7280' }}>{placed.length}/{set.items.length}</span>
      </div>

      {/* Progress bar */}
      <div style={{ height:6, background:'#e5e7eb', borderRadius:99, marginBottom:12, overflow:'hidden' }}>
        <div style={{ height:'100%', width:`${placed.length/set.items.length*100}%`,
          background:color, borderRadius:99, transition:'width 0.3s' }} />
      </div>

      {/* Unsorted items */}
      <div style={{ display:'flex', flexWrap:'wrap', gap:7, justifyContent:'center', minHeight:46, marginBottom:14 }}>
        {unsorted.map(it => {
          const fl = flash?.id===it.id; const isSel = sel===it.id;
          return (
            <button key={it.id} onClick={() => pick(it.id)} className="btn-bounce"
              style={{
                background: fl ? (flash!.ok?'linear-gradient(135deg,#bbf7d0,#d1fae5)':'linear-gradient(135deg,#fee2e2,#fecaca)')
                  : isSel ? `linear-gradient(135deg,${color},${dark})` : 'linear-gradient(135deg,#f8fafc,#f1f5f9)',
                border: `2.5px solid ${fl?(flash!.ok?'#10b981':'#ef4444'):isSel?color:'#e2e8f0'}`,
                borderRadius:12, padding:'8px 13px', fontSize:12, fontWeight:900,
                color: isSel?'#fff':'#374151',
                cursor:'pointer', transition:'all 0.15s',
                boxShadow: isSel?`0 4px 12px ${color}55`:'0 2px 5px rgba(0,0,0,0.08)',
                animation: fl&&!flash!.ok?'shake 0.4s':'none',
              }}>
              {it.l}
            </button>
          );
        })}
        {allDone && (
          <div style={{ fontSize:15, fontWeight:900, color, animation:'tada 0.5s',
            width:'100%', textAlign:'center' }}>🎉 Perfectly sorted!</div>
        )}
      </div>

      {/* Buckets */}
      <div style={{ display:'grid', gridTemplateColumns:`repeat(${set.cats.length},1fr)`, gap:8 }}>
        {set.cats.map((cat, ci) => (
          <div key={cat}
            style={{ borderRadius:16, overflow:'hidden',
              border:`2.5px solid ${sel?set.clrs[ci]:'#e2e8f0'}`,
              boxShadow: sel?`0 4px 16px ${set.clrs[ci]}44`:'0 2px 8px rgba(0,0,0,0.06)',
              transition:'all 0.2s', transform:sel?'scale(1.02)':'scale(1)',
              cursor:sel?'pointer':'default' }}
            onClick={() => drop(cat)}>
            {/* Colored header band */}
            <div style={{ background:`linear-gradient(135deg,${set.clrs[ci]},${set.clrs[ci]}bb)`,
              padding:'8px 6px', textAlign:'center' }}>
              <div style={{ fontSize:11, fontWeight:900, color:'#fff', letterSpacing:0.5 }}>
                {set.labels[ci]}
              </div>
            </div>
            {/* Drop zone body */}
            <div style={{ background:set.clrs[ci]+'12', minHeight:64, padding:6,
              display:'flex', flexWrap:'wrap', gap:4, alignContent:'flex-start', justifyContent:'center' }}>
              {sorted[cat].map((id: string) => {
                const it = set.items.find(x => x.id===id)!;
                return (
                  <span key={id}
                    style={{ background:set.clrs[ci]+'22', border:`1.5px solid ${set.clrs[ci]}`,
                      borderRadius:8, padding:'3px 8px', fontSize:10, fontWeight:900,
                      color:set.clrs[ci], animation:'dropIn 0.35s' }}>
                    {it.l}
                  </span>
                );
              })}
              {sorted[cat].length===0 && (
                <div style={{ color:set.clrs[ci]+'55', fontSize:10, fontWeight:700,
                  margin:'auto', paddingTop:12 }}>
                  Drop here ↓
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
